export const CONSTANTS = {
  DEFAULT_PAGE_VALUE: 1,
  DEFAULT_LIMIT_VALUE: 10,
};